import { useCallback, useState } from "react";
import { usePortalMenu } from "../../../hooks/usePortalMenu";

/**
 * Open state plus portal refs for a Dropdown that manages itself. `active` is false when the
 * caller controls the Dropdown, so the portal listeners stay off.
 */
export const useDropdownInternalState = (active: boolean) => {
  const [isOpen, setIsOpen] = useState(false);
  const onClose = useCallback(() => setIsOpen(false), []);
  const onToggle = useCallback(() => setIsOpen((o) => !o), []);
  const { triggerRef, menuRef, rect } = usePortalMenu<HTMLButtonElement, HTMLUListElement>({
    open: active && isOpen,
    onOutsideClick: onClose,
  });
  return { isOpen: active && isOpen, onClose, onToggle, triggerRef, menuRef, rect };
};
